"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var odc_frame_1 = __importDefault(require("@tencent/odc-frame"));
var Card = function Card(props, ref) {
  var _a;
  var children = props.children,
    body = props.body,
    _b = props.useCardClassName,
    useCardClassName = _b === void 0 ? true : _b,
    _c = props.padding,
    padding = _c === void 0 ? '0' : _c,
    _d = props.radius,
    radius = _d === void 0 ? '8' : _d,
    _e = props.bordered,
    bordered = _e === void 0 ? true : _e,
    _f = props.bg,
    bg = _f === void 0 ? 'white' : _f,
    _g = props.baseClass,
    baseClass = _g === void 0 ? 'card' : _g,
    header = props.header,
    _h = props.headerBg,
    headerBg = _h === void 0 ? 'rgba(249,250,252,.5)' : _h,
    headerMinHeight = props.headerMinHeight,
    headerClassName = props.headerClassName,
    hideHeaderDivider = props.hideHeaderDivider,
    headerProps = props.headerProps,
    footer = props.footer,
    footerClassName = props.footerClassName,
    hideFooterDivider = props.hideFooterDivider,
    footerProps = props.footerProps,
    bodyClassName = props.bodyClassName,
    bodyProps = props.bodyProps,
    _j = props.headerPadding,
    headerPadding = _j === void 0 ? '16-24' : _j,
    bodyPadding = props.bodyPadding,
    footerPadding = props.footerPadding,
    restProps = __rest(props, ["children", "body", "useCardClassName", "padding", "radius", "bordered", "bg", "baseClass", "header", "headerBg", "headerMinHeight", "headerClassName", "hideHeaderDivider", "headerProps", "footer", "footerClassName", "hideFooterDivider", "footerProps", "bodyClassName", "bodyProps", "headerPadding", "bodyPadding", "footerPadding"]);
  var content = children || body;
  return react_1["default"].createElement(odc_frame_1["default"], __assign({}, restProps, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])((_a = {}, _a["".concat(baseClass)] = useCardClassName, _a.border = bordered, _a), 'odc-card'),
    supportAllEvents: true,
    ref: ref
  }, Card), {
    padding: padding,
    radius: radius,
    bg: bg
  }), header ? react_1["default"].createElement(odc_frame_1["default"], __assign({
    fill: headerBg,
    radius: radius,
    padding: headerPadding,
    minHeight: headerMinHeight,
    className: (0, classnames_1["default"])('odc-card-header radius-b-none', {
      'border-b': !hideHeaderDivider
    }, headerClassName)
  }, headerProps), header) : null, !(header || footer) ? content : react_1["default"].createElement(odc_frame_1["default"], __assign({
    padding: bodyPadding,
    className: (0, classnames_1["default"])('odc-card-body', {}, bodyClassName)
  }, bodyProps), content), footer ? react_1["default"].createElement(odc_frame_1["default"], __assign({
    radius: radius,
    padding: footerPadding,
    className: (0, classnames_1["default"])('odc-card-footer radius-t-none', {
      'border-t': !hideFooterDivider
    }, footerClassName)
  }, footerProps), footer) : null);
};
(0, spaui_utils_1.setComponentMark)(Card, info_1["default"]);
exports["default"] = react_1["default"].memo(react_1["default"].forwardRef(Card));